<div class="container-fluid bg-img">
  <div class="row min-vh-100 auth-layout-row">
    <div class="col-md-8 left-section">
      <div class="row">
        <div class="col-md-6 offset-md-1 pt-5">
          <img src="assets\img\background\NBR_logo.jpg" (click)="navigateToLandingPage()" style="cursor: pointer;">
          <!-- <h1>eReturn</h1> -->
        </div>
        <div class="col-md-4 offset-md-1 pt-5 justify-content-end">
          <img src="assets\img\logo\eReturn_Logo.svg" style="float: right; padding-right: 20px; width: 65%;">
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center announcement-section" #announcementSection *ngIf="showAnnouncementSection">
        <div class="col-md-10 offset-md-1 pt-4">
          <div class="maintenance-announcement-card">
            <div class="row no-gutters align-items-center">
              <div class="col-md-4 maintenance-illustration-col">
                <img
                  class="maintenance-illustration"
                  src="assets/img/logo/maintainence.png"
                  alt="Maintenance illustration"
                />
              </div>
              <div class="col-md-8 maintenance-content-col">
                <div class="maintenance-header">
                  <span class="maintenance-header-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="3" y="4" width="18" height="17" rx="2" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M3 9H21" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M8 2V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M16 2V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <circle cx="12" cy="15" r="3" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M12 13.5V15L13 16" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
                    </svg>
                  </span>
                  <h4 class="maintenance-title" *ngIf="announcementPhase === 'pre-maintenance'">Return submission will be unavailable shortly.</h4>
                  <h4 class="maintenance-title" *ngIf="announcementPhase === 'during-maintenance'">Return submission will resume shortly.</h4>
                </div>

                <p class="maintenance-message">
                  Please be informed that the return submission will remain unavailable for
                  <strong>30 minutes</strong> on
                </p>
                <p class="maintenance-schedule">
                  <strong>1 October 2026, from 12:00 AM to 12:30 AM</strong>
                </p>

                <div class="maintenance-timer-box">
                  <div class="maintenance-timer-label">
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    <span *ngIf="announcementPhase === 'pre-maintenance'">
                      Return submission will be unavailable in
                    </span>
                    <span *ngIf="announcementPhase === 'during-maintenance'">
                      Return submission resumes in
                    </span>
                  </div>
                  <div
                    class="maintenance-timer-display"
                    [class.timer-pre-maintenance]="announcementPhase === 'pre-maintenance'"
                    [class.timer-during-maintenance]="announcementPhase === 'during-maintenance'"
                  >
                    <div class="timer-unit">
                      <span class="timer-value">{{ countdownHours }}</span>
                      <span class="timer-caption">Hours</span>
                    </div>
                    <span class="timer-separator">:</span>
                    <div class="timer-unit">
                      <span class="timer-value">{{ countdownMinutes }}</span>
                      <span class="timer-caption">Minutes</span>
                    </div>
                    <span class="timer-separator">:</span>
                    <div class="timer-unit">
                      <span class="timer-value">{{ countdownSeconds }}</span>
                      <span class="timer-caption">Seconds</span>
                    </div>
                  </div>
                </div>

                <p class="maintenance-footer" *ngIf="announcementPhase === 'pre-maintenance'">
                  Please submit your return before this time to avail 1st Quarter Incentive.
                </p>
                <p class="maintenance-footer" *ngIf="announcementPhase === 'during-maintenance'">
                  Thank you for your patience
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 shadow bg-grey auth-form-column">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
